export enum FavouritesStatus{
    UNKNOWN,
    LIVE,
    DELETE
}